"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingCancelButton = exports.SettingSaveButton = exports.SettingSaveCancelWrapper = exports.SettingChangeButton = exports.SettingRegisterButton = exports.numberInputCss = exports.SettingInput = exports.SettingInputWrapper = exports.SettingSubTitle = exports.SettingContentsWrapper = exports.SettingTitle = exports.SettingWrapper = void 0;
const Button_1 = __importDefault(require("@mui/material/Button"));
const styled_1 = __importDefault(require("@emotion/styled"));
exports.SettingWrapper = styled_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 10px;
  background-color: var(--white);
`;
exports.SettingTitle = styled_1.default.div `
  padding: 20px 16px 10px;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.5;
  color: var(--gray-80);
`;
exports.SettingContentsWrapper = styled_1.default.div `
  padding: 20px 16px;
  h5,
  h6 {
    /* error or help message */
    margin-top: 3px;
    line-height: 20px;
    font-size: 14px;
    white-space: pre-wrap;
  }
  h6 {
    display: flex;
    align-items: center;
  }
`;
exports.SettingSubTitle = styled_1.default.div `
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-weight: 400;
  font-size: 15px;
  line-height: 1.5;
  color: var(--gray-80);
`;
exports.SettingInputWrapper = styled_1.default.div `
  flex-grow: 1;
  position: relative;
  display: flex;
  align-items: center;
`;
exports.SettingInput = styled_1.default.input `
  width: 100%;
  padding: 14px 12px;
  border: 1px solid var(--gray-10);
  border-radius: 8px;
  line-height: 18px;
  font-size: 15px;
  color: var(--gray-80);
  :disabled {
    border: 1px solid var(--gray-10);
    background-color: var(--surface-bg);
    opacity: 1;
    -webkit-text-fill-color: var(--gray-80);
  }
`;
exports.numberInputCss = {
    width: '100%',
    padding: '14px 12px',
    paddingRight: '64px',
    border: '1px solid var(--gray-10)',
    borderRadius: '8px',
    lineHeight: '18px',
    fontSize: '15px',
    color: 'var(--gray-80)',
    ':disabled': {
        border: '1px solid var(--gray-10)',
        backgroundColor: 'var(--surface-bg)',
        opacity: '1',
        WebkitTextFillColor: 'var(--gray-80)',
    },
};
exports.SettingRegisterButton = (0, styled_1.default)(Button_1.default) `
  position: absolute;
  right: 10px;
  min-width: 50px;
  height: 28px;
  padding: 0 12px;
  border-radius: 6px;
  font-size: 14px;
  line-height: 17px;
  background-color: var(--gray-80) !important;
  color: white !important;
`;
exports.SettingChangeButton = (0, styled_1.default)(Button_1.default) `
  position: absolute;
  right: 10px;
  min-width: 50px;
  height: 28px;
  padding: 0 12px;
  border: 1px solid var(--gray-80);
  border-radius: 6px;
  font-size: 14px;
  line-height: 17px;
  background-color: white !important;
  color: var(--gray-80);
`;
// ! SettingContentsWrapper 아래에 위치하여야 함.
exports.SettingSaveCancelWrapper = styled_1.default.div `
  display: flex;
  justify-content: flex-end;
  column-gap: 10px;
  padding: 0 16px 20px;
`;
exports.SettingSaveButton = (0, styled_1.default)(Button_1.default) `
  min-width: 80px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
  color: white;
  background-color: var(--primary-main) !important;
`;
exports.SettingCancelButton = (0, styled_1.default)(Button_1.default) `
  min-width: 80px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid var(--gray-10);
  font-size: 15px;
  color: var(--gray-80);
  background-color: white !important;
`;
